import classnames from "classnames"

import Styles from "./RadioButton.module.scss"

interface RadioButtonProps {
    id: any;
    value: string | number;
    isChecked: boolean;
    label?: any;
    handleOptionClick: (id: any, onClick?: any) => void;
    onClick?: (data?: any) => void;
    size?: "small" | "medium";
    layout?: "flex" | "block";
}

const RadioButton = ({
    id,
    value,
    isChecked,
    label,
    size = "medium",
    layout = "block",
    onClick,
    handleOptionClick,
}: RadioButtonProps) => {
    return (

        <div className={classnames(Styles[layout], Styles[size])}>
            <label>
                <input
                    type="radio"
                    value={value}
                    checked={isChecked}
                    onChange={() => { handleOptionClick(id, onClick) }}
                />
                <span
                    className={Styles.checkmark}>
                </span>
                {label && label}
            </label>
        </div>
    )
}

export default RadioButton
